import {AddMenuHeadingAction} from "../../../../store/Menu/Action";
import {addSessionData} from "../../Base/helper/baseHelper";

export const getRedirectRouteFromSearch = (searchStr) => {
  const search = searchStr !== undefined ? searchStr
      : typeof window !== "undefined" ? window.location.search : "";
  if (!search) return "";
  try {
    const params = new URLSearchParams(search);
    const redirectParam = params.get("redirect");
    if (redirectParam) {
      return redirectParam.startsWith("/") ? redirectParam : `/${redirectParam}`;
    }
  } catch (e) {}
  return "";
};

// Generic route access checker using atsModuleData (from GetATSModuleAction) and userData.

export const checkRouteAccess = (route, atsModuleData = [], userData = {}) => {
  if (!route) return false;
  const pathname = route.split("?")[0].split("#")[0].trim().replace(/\/+$/, "") || "/";
  if (pathname === "" || pathname === "/" || pathname === "/home") {
    return true;
  }
  const atsDashboarAccess = atsModuleData?.some((item) => item?.module_name === "ATS Dashboard");
  const ATSAccess = atsModuleData?.some((item) => item?.module_name === "ATS");
  const atsHiringRequestAccess = atsModuleData?.some((item) => item?.module_name === "MPR");
  const atsMPRApproverAccess = atsModuleData?.some((item) => item?.module_name === "MPR Approver");

  const routeModuleMap = [
    {
      routes: ["/ats/hiring-requests"],
      check: () => userData?.enable_ats && userData?.enable_ats_user && 
      atsDashboarAccess && ATSAccess && atsHiringRequestAccess && atsMPRApproverAccess
    },
  ];

  const matched = routeModuleMap?.find((item) =>
    item?.routes?.some((r) => {
      const cleanR = r?.replace(/\/+$/, ""); //removes trailing slashes (/) from the end of the route
      return pathname === cleanR || pathname?.startsWith(cleanR + "/");
    })
  );
  if (matched) {
    return Boolean(matched?.check());
  }

  return false;
};

// Resolves post-login destination route by checking query routes and verifying user access.

export const resolvePostLoginNavigation = (
  atsModuleData,
  userData,
  dispatch
) => {

  const targetRoute = getRedirectRouteFromSearch(window.location.search) || sessionStorage.getItem("post_login_redirect");
  sessionStorage.removeItem("post_login_redirect");
  if (targetRoute && checkRouteAccess(targetRoute, atsModuleData, userData)) {
    return targetRoute;
  }

  addSessionData({ key: "selectedMenu", value: "Home" });
  sessionStorage.setItem("selectedMenu", "Home");
  if (dispatch) {
    dispatch(AddMenuHeadingAction({ heading: "Home" }));
  }
  return "/home";
};